/**试卷模块 */
import request from '../request/http';
/**新增试卷 */
export function AddTestPaper(data){
    return request({
        url: '/sp/testPaper/addTestPaper',
        method: 'post',
        data
    })
}
/**分页查询试卷 */
export function PaperPageList(data){
    return request({
        url: '/sp/testPaper/pageList',
        method: 'post',
        data
    })
}
/**删除试卷 */
export function DelTestPaper(data){
    return request({
        url: '/sp/testPaper/delTestPaper',
        method: 'post',
        data
    })
}
/**获取试卷详情 */
export function GetTestPaperInfo(data){
    return request({
        url: '/sp/testPaper/getTestPaperInfo',
        method: 'post',
        data
    })
}
/**修改试卷 */
export function UpdateTestPaper(data){
    return request({
        url: '/sp/testPaper/updateTestPaper',
        method: 'post',
        data
    })
}
/**试卷共享 */
export function ShareTestPaper(data){
    return request({
        url: '/sp/testPaper/shareTestPaper',
        method: 'post',
        data
    })
}
/**取消试卷共享 */
export function CancelShareTestPaper(data){
    return request({
        url: '/sp/testPaper/cancelShareTestPaper',
        method: 'post',
        data
    })
}
/**分页查询课程试卷 */
export function PageCourseTestPaperList(data){
    return request({
        url: '/sp/testPaper/pageCourseTestPaperList',
        method: 'post',
        data
    })
}
/**试卷课程绑定-解绑 */
export function BindOrUnbindCourse(data){
    return request({
        url: '/sp/testPaper/bindOrUnbindCourse',
        method: 'post',
        data
    })
}
/**获取试卷题目数据 */
export function GetTestPaperQuestion(data){
    return request({
        url: '/sp/testPaper/getTestPaperQuestion',
        method: 'post',
        data
    })
}
/**获取用户答题记录 */
export function GetUserAnswerRecord(data){
    return request({
        url: '/sp/testPaper/getUserTestPaperInfo',
        method: 'post',
        data
    })
}
/**提交试卷 */
export function SubmitTestPaper(data){
    return request({
        url: '/sp/testPaper/submitTestPaper',
        method: 'post',
        data
    })
}
/**开始考试 */
export function StartExam(data){
    return request({
        url: '/sp/testPaper/startExam',
        method: 'post',
        data
    })
}
/**更新考试剩余时间 */
export function UpdateRemainingTime(data){
    return request({
        url: '/sp/testPaper/updateRemainingTime',
        method: 'post',
        data
    })
}
/**分页查询我收藏试卷 */
export function PageQueryMyCollectList(data){
    return request({
        url: '/sp/testPaper/pageQueryMyCollectList',
        method: 'post',
        data
    })
}
/**试卷重置 */
export function TestPaperReset(data){
    return request({
        url: '/sp/testPaper/testPaperReset',
        method: 'post',
        data
    })
}
/**分页查询试卷题目 */
export function PageQueryTestPaperQuestion(data){
    return request({
        url: '/sp/testPaper/pageQueryTestPaperQuestion',
        method: 'post',
        data
    })
}
/**分页查询试卷题目 */
export function PageQueryPaperCourse(data){
    return request({
        url: '/sp/testPaper/pageQueryPaperCourse',
        method: 'post',
        data
    })
}